export default __webpack_public_path__ + "static/media/carousel-img-8.67b8719c.png";